import { createSlice } from '@reduxjs/toolkit';
import { AssetCategoryState } from './assetCategoryTypes';
import { 
  createAssetCategory, 
  fetchAssetCategoryById, 
  fetchAllAssetCategories, 
  updateAssetCategory, 
  deleteAssetCategory 
} from './assetCategoryActions';

const initialState: AssetCategoryState = {
  assetCategories: [],
  selectedCategory: undefined,
  loading: false,
  error: undefined,
};

const assetCategorySlice = createSlice({
  name: 'assetCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Asset Category
      .addCase(createAssetCategory.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createAssetCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.assetCategories.push(action.payload);
      })
      .addCase(createAssetCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Asset Category by ID
      .addCase(fetchAssetCategoryById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAssetCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategory = action.payload.data;
      })
      .addCase(fetchAssetCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Asset Categories
      .addCase(fetchAllAssetCategories.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllAssetCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.assetCategories = action.payload.data;
      })
      .addCase(fetchAllAssetCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Asset Category
      .addCase(updateAssetCategory.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateAssetCategory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.assetCategories.findIndex(category => category.id === action.payload.id);
        if (index !== -1) {
          state.assetCategories[index] = action.payload;
        }
      })
      .addCase(updateAssetCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Asset Category
      .addCase(deleteAssetCategory.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteAssetCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.assetCategories = state.assetCategories.filter(category => category.id !== action.payload.id);
      })
      .addCase(deleteAssetCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default assetCategorySlice.reducer;
